import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import { Contents , 
            Schedule, 
            ScheduleCreate, 
            ScheduleModify,
            BlogsCreate,
            BlogsModify, 
            CardsCreate, 
            CardsModify,
            QuizCreate,
            QuizModify,
            SurveyCreate,
            SurveyModify,
            Project, 
            Tag,
            SignIn,
            SignUp,
            PasswordReset,
            Organization,
            BlogViewer,
            SliderViewer,
            Delivery,
            Forward,
            Error } from './pages';


class Router extends Component {

    render() {
        
        const isViewer = (window.location.href.indexOf('viewer') > 0);
        const isSign = (window.location.href.indexOf('sign') > 0);

      if(!isSign && !isViewer) {
            if(!window.sessionStorage.loginToken) {
                window.location.href = '/signin';
                return null;
            }
      }
        
        return (
            <React.Fragment>
                <Switch>
                    <Route exact path="/" component={Schedule}/>

                    <Route path="/schedule/:type/:projectId/:programId" component={Schedule}/>
                    <Route path="/schedule" component={Schedule}/>
                    <Route path="/schedulecreate" component={ScheduleCreate}/>
                    <Route path="/schedulecreatemessage/:type/:projectId/:programId" component={ScheduleCreate}/>
                    <Route path="/schedulecreatecontent/:type/:projectId/:programId" component={ScheduleCreate}/>
                    <Route path="/schedulemodify/:type/:projectId/:programId/:scheduleId" component={ScheduleModify}/>
                    <Route path="/contents/blogscreate" component={BlogsCreate}/>
                    <Route path="/contents/blogsmodify/:id" component={BlogsModify}/>
                    <Route path="/contents/cardscreate" component={CardsCreate}/>
                    <Route path="/contents/cardsmodify/:id" component={CardsModify}/>
                    <Route path="/contents/quizcreate" component={QuizCreate}/>
                    <Route path="/contents/quizmodify/:id" component={QuizModify}/>
                    <Route path="/contents/surveyscreate" component={SurveyCreate}/>
                    <Route path="/contents/surveysmodify/:id" component={SurveyModify}/>
                    <Route path="/blogviewer/:id" component={BlogViewer}/>
                    <Route path="/caredviewer/:id" component={SliderViewer}/>
                    <Route path="/contents/:type" component={Contents}/>
                    <Route path="/contents" component={Contents}/>
   
                    <Route exact path="/project" component={Project}/>
                    <Route exact path="/tag" component={Tag}/>
                    <Route exact path="/delivery" component={Delivery}/>
                    <Route exact path="/signin" component={SignIn}/>
                    <Route exact path="/signup" component={SignUp}/>
                    <Route exact path="/sign/password/reset" component={PasswordReset}/>
                    <Route exact path="/organization" component={Organization}/>
                    <Route exact path="/forward" component={Forward}/>
                    <Route component={Error}/>
                </Switch>
            </React.Fragment>

        );
    }
}

export default Router;